import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { AmazonRedshiftCopySource } from 'app/model/pipeline/copysource/amazon-redshift.copysource';
import { ReferenceAdapter } from 'app/model/adapters/reference.adapter';
import { LinkedService } from 'app/model/linkedservice/linkedservice';
import { RelationalCopySourceAdapter } from 'app/model/adapters/activities/copysource/relational.copysource.adapter';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { commonCopySourceAdapts } from './copysource.adapter';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AmazonRedshiftCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*',
        redshiftUnloadSettings: '*'
    }
})
export class AmazonRedshiftCopySourceAdapter extends RelationalCopySourceAdapter {
    protected override async _toResource(copySource: AmazonRedshiftCopySource): Promise<Model.AmazonRedshiftSource> {
        const result: Model.AmazonRedshiftSource = await super._toResource(copySource);
        result.type = adfModelTypeMap.amazonRedshift.copySourceType;
        const bucketNameValue = ValueAdapter.toResource(copySource, AmazonRedshiftCopySource.BUCKET_NAME);
        if (copySource.enableRedshiftUnloadSettings && copySource.linkedService && bucketNameValue) {
            result.redshiftUnloadSettings = {
                s3LinkedServiceName: ReferenceAdapter.toResource(
                    copySource.linkedService,
                    this.context
                ) as Model.LinkedServiceReference,
                bucketName: bucketNameValue
            };
        }
        return result;
    }

    protected override async _toModel(
        resource: Model.AmazonRedshiftSource,
        copyActivity: CopyActivity
    ): Promise<AmazonRedshiftCopySource> {
        const result = this.createCopySourceWithCommonProperties(
            AmazonRedshiftCopySource.MODEL,
            resource,
            copyActivity
        ) as AmazonRedshiftCopySource;
        if (resource.query) {
            ValueAdapter.toModel(result, AmazonRedshiftCopySource.READER_QUERY, resource.query);
            result.mode = 'query';
        }
        if (resource.redshiftUnloadSettings) {
            result.enableRedshiftUnloadSettings = true;
            const s3LinkedServiceName =
                resource.redshiftUnloadSettings.s3LinkedServiceName ||
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (resource.redshiftUnloadSettings as any)['s3linkedServiceName'];
            if (s3LinkedServiceName) {
                result.linkedService = ReferenceAdapter.toProxyModel<LinkedService>(
                    Metamodel.modelFor(LinkedService),
                    s3LinkedServiceName, this.context
                );
            }
            ValueAdapter.toModel(
                result,
                AmazonRedshiftCopySource.BUCKET_NAME,
                resource.redshiftUnloadSettings.bucketName
            );
        } else {
            result.enableRedshiftUnloadSettings = false;
        }
        return result;
    }
}
